import Grid from '@mui/material/Grid/Grid'
import { Link } from 'react-router-dom'
import { ArrowForward } from '@mui/icons-material'

const CarouselCoachCard = ({
  title,
  description,
  ctaLink
}: {
  title: string
  description: string
  ctaLink: string
}) => {
  return (
    <Grid
      container
      item
      direction="column"
      xs={6}
      sm={4}
      md={3}
      lg={2}
      className={`h-full min-w-[70%] !p-[6px] sm:min-w-[40%] md:min-w-[25%] lg:min-w-[16%] `}
    >
      <div className={`card-moment h-full `}>
        <div className={`flex h-full flex-col rounded-[10px] bg-card p-4`}>
          <div className="flex-1 pt-2">
            <p className="pb-1 text-[20px] font-bold leading-[24px]">{title}</p>
            <p className="leading-[24px]">{description}</p>
          </div>
          <Link to={ctaLink} className="flex w-min rounded-[50%] bg-blue2 p-2">
            <ArrowForward className="text-white" />
          </Link>
        </div>
      </div>
    </Grid>
  )
}

export default CarouselCoachCard
